export const options = {
  paging: true,
  autoWidth: true,
  order: [],
  columnDefs: [{ targets: "_all", orderable: true }],
  pagingType: "simple_numbers",
  language: {
    paginate: {
      next: "Next",
      previous: "Previous",
    },
    info: "Showing _START_ to _END_ of _TOTAL_ entries",
  },
  dom:
    "<'row'<'col-sm-12 col-md-6'><'col-sm-12 col-md-6 mb-2'f>>" +
    "<'row'<'col-sm-12'tr>>" +
    "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 d-flex justify-content-end'p>>",
};

export const columns = [
  { title: "id", data: "id", visible: false },
  { title: "FULL NAMES", data: "name" },
  { title: "USERNAME", data: "email" },
  {
    title: "Action",
    data: null,
    defaultContent: "",
    orderable: false,
    width: "200px",
    render: (data) => {
      const rowData = JSON.stringify(data).replace(/"/g, "&quot;");
      return `<button
            class="btn btn-warning edit-user-btn w-100" data="${rowData}"
          >Edit</button>`;
    },
  },
];
